import { useContext } from "react"
import { SOFormContext } from "../../pages/SOForm"


export const EventDialog = () => {
    const { SOFormUser, setSOFormUser } = useContext(SOFormContext)

    const handelSubmit = (e) => {
        e.preventDefault()
        if (Object.keys(SOFormUser.eventData).length === 0) {
            setSOFormUser((prev) => ({ ...prev, msg: 'You must select an event.' }))
            return
        }
        setSOFormUser((prev) => ({ ...prev, currStage: 'PriceDialog' }))
    }
    const handleChange = (event) => {
        setSOFormUser((prev) => ({ ...prev, eventData: event, msg: '' }))
    }

    return (
        <form onSubmit={handelSubmit} className='event-dialog dialog'>
            <h1>Top Innovator Application</h1>
            <p>Select the Event at which You Would Like to Present</p>
            {SOFormUser.upcomingEvents.map((event, index) =>
                <label key={index}>
                    <div>
                        <img src={event.event_logo} alt="" />
                        <p>{event.dates_str}</p>
                    </div>
                    <input
                        type="checkbox"
                        checked={SOFormUser.eventData === event}
                        onChange={() => handleChange(event)}
                    />
                </label>
            )}
            {SOFormUser.msg && <div className="msg">{SOFormUser.msg}</div>}
            <div className='btn-container'>
                <button type="submit" className='btn'>Continue</button>
            </div>
        </form>
    )
}





